import React from "react";
import Card from "components/card";
import Chart from "react-apexcharts";

const CrawlerTypeDistChart = ({ rows }) => {
  const counts = React.useMemo(() => {
    let fashion = 0, bridal = 0, both = 0, neither = 0;
    (rows || []).forEach((row) => {
      const typeText = (row?.type || "").toString().toLowerCase();
      const descText = (row?.imageDesc || "").toString().toLowerCase();
      const hasFashion = typeText.includes("fashion") || descText.includes("fashion");
      const hasBridal = typeText.includes("bridal") || descText.includes("bridal");
      if (hasFashion && hasBridal) both++;
      else if (hasFashion) fashion++;
      else if (hasBridal) bridal++;
      else neither++;
    });
    return { fashion, bridal, both, neither };
  }, [rows]);

  const total = counts.fashion + counts.bridal + counts.both + counts.neither;

  if (total === 0) {
    return (
      <Card extra="p-5">
        <h4 className="text-base font-bold text-navy-700 dark:text-white mb-4 font-dm">
          Category Distribution
        </h4>
        <div className="flex items-center justify-center h-64">
          <p className="text-gray-500 dark:text-gray-400 text-sm">No data available</p>
        </div>
      </Card>
    );
  }

  const series = [counts.fashion, counts.bridal, counts.both, counts.neither];
  const labels = ["Fashion Only", "Bridal Only", "Fashion & Bridal", "Neither"];
  const colors = ["#ec4899", "#a855f7", "#6366f1", "#94a3b8"];

  return (
    <Card extra="p-5">
      <h4 className="text-base font-bold text-navy-700 dark:text-white mb-1 font-dm">
        Category Distribution
      </h4>
      <p className="text-xs text-gray-500 dark:text-gray-400 mb-4 font-dm">
        Fashion vs Bridal breakdown
      </p>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="flex items-center justify-center" style={{ minHeight: 240 }}>
          <Chart
            type="donut"
            width="100%"
            height={240}
            series={series}
            options={{
              labels,
              colors,
              chart: {
                type: "donut",
                width: "100%",
                height: 240,
                fontFamily: "DM Sans, sans-serif",
              },
              plotOptions: {
                pie: {
                  donut: {
                    size: "55%",
                    labels: {
                      show: true,
                      total: { show: true, label: "Total", formatter: () => total },
                    },
                  },
                },
              },
              legend: { show: false },
              dataLabels: {
                enabled: true,
                formatter: (val) => val.toFixed(1) + "%",
                style: { fontSize: "10px", fontFamily: "DM Sans, sans-serif" },
              },
              tooltip: {
                enabled: true,
                theme: "dark",
                y: {
                  formatter: (value) => {
                    const pct = total > 0 ? ((value / total) * 100).toFixed(1) : "0";
                    return `${value} (${pct}%)`;
                  },
                },
              },
              stroke: { width: 2 },
              states: {
                hover: { filter: { type: "darken", value: 0.9 } },
                active: { filter: { type: "none" } },
              },
            }}
          />
        </div>
        <div className="flex flex-col justify-center space-y-2">
          {labels.map((label, i) => (
            <div
              key={label}
              className="flex items-center justify-between rounded-lg bg-gray-50 px-3 py-2 dark:bg-navy-700"
            >
              <div className="flex items-center gap-2">
                <div className="h-3 w-3 rounded-full" style={{ backgroundColor: colors[i] }} />
                <span className="text-sm font-medium text-navy-700 dark:text-white font-dm">
                  {label}
                </span>
              </div>
              <div className="text-right">
                <span className="text-sm font-bold text-navy-700 dark:text-white font-dm">
                  {series[i]}
                </span>
                <span className="ml-1 text-xs text-gray-500 dark:text-gray-400 font-dm">
                  ({total > 0 ? ((series[i] / total) * 100).toFixed(1) : 0}%)
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
};

export default CrawlerTypeDistChart;
